import script from "./LineEmojiPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./LineEmojiPicker.vue?vue&type=script&setup=true&lang=js"

import "./LineEmojiPicker.vue?vue&type=style&index=0&id=c7df5e74&scoped=true&lang=css"
import "./LineEmojiPicker.vue?vue&type=style&index=1&id=c7df5e74&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7df5e74"]])

export default __exports__